import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useMediaQuery, useTheme } from '@mui/system';

const textStyles = {
  color: '#d1d1d1',
  lineHeight: '1.5rem',
  textAlign: 'right',
  fontSize: {
    xs: '0.8rem',
    sm: '1rem',
    md: '1.2rem'
  }
}

const Header = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <header style={{ height: '6rem', backgroundColor: 'var(--northwestern-purple)', padding: '1rem' }}>
      <Grid container spacing={2} justifyContent={"space-between"} sx={{ height: '100%' }}>
        <Grid size={4} sx={{ height: '100%' }}>
          <img src={isMobile ? '/images/NM_stacked.png' : '/images/feinberg-logo-white.svg'} alt='Feinberg Logo' style={{ height: '100%', width: 'auto' }} />
        </Grid>
        <Grid size={{xs: 8, sm: 6}} sx={{ height: '100%' }}>
          <Typography variant="subtitle1" sx={textStyles}>Northwestern Medicine | Northwestern University</Typography>
          <Typography variant="subtitle1" sx={textStyles}>VU Research Group</Typography>
        </Grid>
      </Grid>
    </header>
  )
}

export default Header;